import React, {useRef, useEffect} from 'react';

const Home = () => {
  const yamang = useRef(null);
  const typed = useRef(null);


  useEffect(() => {
    if (window.Typed) {
      typed.current = new window.Typed(yamang.current, {
        strings: [
          'YAMANG', 
          '<span class="gold" >SOFTWARE ENGINEER</span>', 
          '<span class="purple">PROGRAMMER</span>',
          '<span class="red">FULL STACK DEVELOPER</span>',
        ],
        typeSpeed: 50,
        loop: true,
        smartBackspace: true,
        showCursor: true,
        html: true, // Important for enabling HTML rendering
      });

    }

    return () => {
      if (typed.current) {
        typed.current.destroy();
       
      }
    };
  }, []);


  return (
    <>
      {/* general body seckeleton view */}
      <div className="view">
        {/* header section: contain navbar */}
        <div className="header navBar">
          <div className="yamang logo">YAMANG</div>
          <div className="navLinks intro">
            <a href="#" target="_parent">
              INTRO
            </a>
          </div>
          <div className="navLinks about">
            <a href="#" target="_parent">
              ABOUT
            </a>
          </div>
          <div className="navLinks works">
            <a href="#" target="_parent">
              WORKS
            </a>
          </div>
          <div
            className="navLinks sayHello"
            style={{ color: "rgba(255, 217, 0, 0.953)" }}
          >
            <a href="#" target="_parent">
              SAY HELLO
            </a>
          </div>
        </div>

        {/* content section:  */}
        <div className="section">
          {/* introduction section block */}
          <div className="block introBlock">
            <span style={{ color: "gold" }} >___HELLO  WORLD____</span>
            <h1>
              <span ref={yamang}></span>
            </h1>
            <h2>A SOFTWARE ENGINEER, PROGRAMMER AND FULLSTACK DEVELOPER</h2>
            <h3>I create the following resourses with latest technologies:</h3>
            <ul>
              <li>websites, blogs, and other web based systems</li>
              <li>
                mobile applications / mobile app based systems on both android
                and ios
              </li>
            </ul>
            <br />
            <br />

            <h4 style={{ color: "blue" }}>
              click here to contant mi right now
            </h4>
          </div>







          {/* <div className="block">vkhgi;uguty88;</div>
        <div className="block">
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem, ratione? Non officia nobis quam qui possimus unde 
                reprehenderit esse quis tempore commodi! Rerum vitae aut obcaecati expedita. Tenetur, officiis pariatur.
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et optio aliquam blanditiis minus nam, perspiciatis suscipit ipsa adipisci laborum repellat corporis, autem quam illum cupiditate assumenda sequi voluptatem? Nihil, vero?
                Vitae, ipsa distinctio porro aliquid illum modi doloremque, iste, velit magni veniam minima est assumenda asperiores? Facilis nobis, corrupti ducimus ullam dicta quo iure culpa quae quas aperiam inventore odio.
                Sed dolore illum eaque facere hic minus pariatur quod nesciunt. Doloribus cum optio exercitationem voluptates dignissimos nihil natus blanditiis atque illo? Atque natus unde provident eos, amet possimus quod. Ratione!
                Praesentium, corrupti. Laudantium, sit. Atque inventore, incidunt alias perspiciatis ab illo, maiores, non voluptate iusto voluptatem adipisci distinctio perferendis. Quia odit ex suscipit non consequatur maxime sint commodi. Delectus, ratione.
                Aliquam aut maxime doloremque eveniet ipsam quisquam eligendi eius, ex odit enim officia commodi pariatur est atque excepturi cupiditate voluptatem repudiandae modi minus inventore sapiente id consectetur? Doloremque, nemo numquam?
                Sapiente, blanditiis explicabo? Enim, quas facere! Repellat id explicabo autem fugit veniam tempore corrupti, adipisci voluptatem dicta repudiandae sint? Saepe enim beatae pariatur harum repudiandae ullam voluptatibus dicta? Eos, possimus.
                Velit assumenda illum corporis aliquid excepturi molestiae enim, et molestias suscipit, veritatis, consequuntur quae illo rerum quis dolor aliquam? Similique at nobis quas aliquam atque amet id libero cupiditate velit?
                Sint veritatis odit pariatur placeat amet ea aliquam assumenda. Magni incidunt dolores saepe debitis? Voluptas quasi odio deserunt inventore, id, odit eaque molestiae dignissimos cumque molestias debitis qui nihil quia?
                Sunt tempora accusantium expedita soluta dolore cum eveniet dolor optio? Aliquam et numquam quidem! Cumque inventore autem optio odio possimus. Natus minus deleniti fugit quidem similique. Non corporis aut laudantium.
                Possimus, incidunt ab? Laborum deserunt neque totam tenetur dignissimos, perspiciatis itaque, similique autem iure reprehenderit omnis repellat labore iusto corporis quasi voluptatibus vero ullam voluptatum quod aliquid! Obcaecati, id magni.
                Est, neque! Vero deserunt in quia, nemo unde nam error illum odit rem recusandae commodi! Ducimus, nulla amet facilis neque sequi ipsum laudantium veniam mollitia deserunt nobis natus, nihil cumque.
                Explicabo rem aperiam itaque fugit eum cumque velit? Voluptates vitae esse, aperiam dolorum ipsa minus enim molestiae error possimus rem sunt, perspiciatis quibusdam corrupti! Quo aperiam quasi dicta nobis fugiat.
                Fuga impedit possimus vel numquam dolorem iusto obcaecati est incidunt quisquam. Necessitatibus facere cum aliquam pariatur debitis praesentium ducimus ut. Maiores atque laudantium saepe quibusdam vitae veniam veritatis rerum officia.
                Rerum voluptate neque totam a hic architecto voluptates provident, sunt accusamus quidem dolorum optio, aliquam laboriosam iste laudantium illum. Illo molestias nostrum architecto. Autem at ex molestias optio voluptatem voluptas!
                Distinctio labore excepturi tempore laudantium doloremque error, inventore repellendus perferendis ipsum hic recusandae possimus expedita ad eos ducimus ex repudiandae consequatur! Perferendis minima aut voluptate laboriosam? Nulla possimus iure nobis!
                Veritatis qui corrupti id temporibus, earum ratione? Consequatur, impedit. Culpa cumque praesentium possimus non consequuntur a recusandae, quod ad deserunt magni quos ipsam nobis hic qui dolore illum, ut amet.
                Fuga doloribus temporibus dolores officiis quaerat, eius corrupti recusandae laborum dolore necessitatibus deleniti, a itaque. Iusto, nostrum quod laudantium sequi unde eligendi similique culpa eum libero, soluta veniam, dolorum officiis!
                Ducimus hic dolorem quam nisi laudantium ipsa, fugiat, beatae consequuntur ratione magni dignissimos, officia nemo obcaecati. Eius placeat quibusdam aliquid assumenda tenetur, veniam optio, officiis ullam reiciendis temporibus omnis et.
                Voluptatum laborum laboriosam rerum nihil nobis. Pariatur est nisi recusandae cupiditate, ad expedita nesciunt excepturi blanditiis accusantium quia laudantium unde ratione iste dicta quae animi eum quaerat nam! Nostrum, perspiciatis!
                Vel quo doloremque hic consectetur illo odit, autem numquam debitis soluta? Similique inventore magni minima saepe provident excepturi, numquam enim aut perspiciatis harum molestiae officia suscipit natus at, sunt est!
                Placeat eos ipsa illo repellendus vitae corporis dolores, alias quasi quod pariatur veritatis aperiam earum perferendis vero delectus cum doloremque iusto vel, nesciunt natus consequatur, perspiciatis quis labore officia? Consectetur!

            </p>
        </div>
        <div className="block"></div>
        <div className="block">
            yfyuf
        </div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
